import { CALCULATOR_TYPES } from "constants/calculator";

import styles from "./InvestObjectParameters.module.scss";

export const visibleFields = {
  brokerFee: [
    CALCULATOR_TYPES.BASIC,
    CALCULATOR_TYPES.STANDARD,
    CALCULATOR_TYPES.EXPERT,
    CALCULATOR_TYPES.LIMITED_PRO,
  ],
  propertyTax: [
    CALCULATOR_TYPES.BASIC,
    CALCULATOR_TYPES.STANDARD,
    CALCULATOR_TYPES.EXPERT,
    CALCULATOR_TYPES.LIMITED_PRO,
  ],
  energyEfficiencyClass: [
    CALCULATOR_TYPES.BASIC,
    CALCULATOR_TYPES.STANDARD,
    CALCULATOR_TYPES.EXPERT,
    CALCULATOR_TYPES.LIMITED_PRO,
  ],
  startDate: [],
  orderDate: [CALCULATOR_TYPES.STANDARD,
  CALCULATOR_TYPES.EXPERT, CALCULATOR_TYPES.LIMITED_PRO],
  rentStartDate: [CALCULATOR_TYPES.STANDARD,
  CALCULATOR_TYPES.EXPERT, CALCULATOR_TYPES.LIMITED_PRO],
  finishDate: [CALCULATOR_TYPES.STANDARD,
  CALCULATOR_TYPES.EXPERT, CALCULATOR_TYPES.LIMITED_PRO],
  sonderAfaForced: [CALCULATOR_TYPES.BASIC, CALCULATOR_TYPES.STANDARD,
  CALCULATOR_TYPES.EXPERT],
  managementCost: [CALCULATOR_TYPES.STANDARD,
  CALCULATOR_TYPES.EXPERT, CALCULATOR_TYPES.LIMITED_PRO],
  managementCostGrowth: [CALCULATOR_TYPES.STANDARD,
  CALCULATOR_TYPES.EXPERT, CALCULATOR_TYPES.LIMITED_PRO],
  maintenanceCostPerSqMeter: [
    CALCULATOR_TYPES.STANDARD,
    CALCULATOR_TYPES.EXPERT,
    CALCULATOR_TYPES.LIMITED_PRO,
  ],
  maintenanceCostPerSqMeterGrowth: [
    CALCULATOR_TYPES.STANDARD,
    CALCULATOR_TYPES.EXPERT,
    CALCULATOR_TYPES.LIMITED_PRO,
  ],
  downtimePercentage: [CALCULATOR_TYPES.STANDARD,
  CALCULATOR_TYPES.EXPERT, CALCULATOR_TYPES.LIMITED_PRO],
  priceGrowthRelationType: [CALCULATOR_TYPES.STANDARD,
  CALCULATOR_TYPES.EXPERT],
  priceGrowthDate: [CALCULATOR_TYPES.STANDARD,
  CALCULATOR_TYPES.EXPERT, CALCULATOR_TYPES.LIMITED_PRO],
};

export const disabledFields = {
  startDate: [CALCULATOR_TYPES.LIMITED_PRO],
  brokerFee: [CALCULATOR_TYPES.LIMITED_PRO],
  propertyTax: [CALCULATOR_TYPES.LIMITED_PRO],
  energyEfficiencyClass: [CALCULATOR_TYPES.LIMITED_PRO],
  sonderAfaForced: [CALCULATOR_TYPES.LIMITED_PRO],
  finishDate: [CALCULATOR_TYPES.LIMITED_PRO],
  priceGrowthDate: [CALCULATOR_TYPES.LIMITED_PRO],
};

export const defaultFieldProps = {
  variant: "horizontal",
};

export const defaultFieldGroupProps = {
  label: "",
  variant: "horizontal",
  className: styles.fieldGroupControl,
  controlMultiple: true,
};
